module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    class: [
      'btn-' + _vm.theme,
      'btn-' + _vm.size,
      _vm.block ? 'btn-block' : ''
    ],
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
    staticClass: "icon iconfont",
    class: [_vm.icon ? 'icon-' + _vm.icon : '']
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
    staticClass: "icon iconfont icon-loading loading"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d0d5bef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/btn/btn.vue
// module id = 6
// module chunks = 1 2 3 5 11 23 24